import { httpsCallable } from 'firebase/functions';
import type { FounderUpdateIntelligence } from '../types';
import { functions } from './firebase';

export type AnalyzeFounderUpdateResponse = {
  updateIntelligence: FounderUpdateIntelligence;
};

export function analyzeFounderUpdateErrorMessage(err: unknown): string {
  if (err && typeof err === 'object' && 'message' in err) {
    const message = String((err as { message: string }).message);
    if (message && !message.startsWith('Firebase')) {
      return message;
    }
  }
  if (err && typeof err === 'object' && 'code' in err) {
    const code = String((err as { code: string }).code);
    if (code === 'functions/invalid-argument') {
      return 'Add at least 200 characters of founder update text (or upload a PDF with embedded text) before analyzing.';
    }
    if (code === 'functions/not-found') {
      return 'Monthly report not found.';
    }
    if (code === 'functions/permission-denied') {
      return 'You do not have permission to analyze this report.';
    }
    if (code === 'functions/unauthenticated') {
      return 'Sign in to analyze the update.';
    }
    if (code === 'functions/unavailable') {
      return 'Analysis service is temporarily unavailable. Try again.';
    }
    if (code === 'functions/failed-precondition') {
      return 'PDF exceeds size limit or report is missing required data.';
    }
    if (code === 'functions/internal' || code === 'functions/deadline-exceeded') {
      return 'Analysis failed. Try again or check report text.';
    }
  }
  return err instanceof Error ? err.message : 'Founder update analysis failed.';
}

export async function analyzeFounderUpdate(monthlyUpdateId: string): Promise<FounderUpdateIntelligence> {
  const fn = httpsCallable<{ monthlyUpdateId: string }, AnalyzeFounderUpdateResponse>(
    functions,
    'analyzeFounderUpdate'
  );
  const result = await fn({ monthlyUpdateId: monthlyUpdateId.trim() });
  return result.data.updateIntelligence;
}
